export default __webpack_public_path__ + "static/media/night-visions.9a2a2816.jpg";